// Require Stripe Checkout.js and JQuery

function stripeCheckoutHandler(totalPrice, cartItems, contactAndAdress){

    // Only keep product names and qtys
    var items = cartItems.reduce(function(items, item){
        return items.concat({
            name: item.title,
            qty: item.quantity
        })
    }, []);



    // Setup stripe. Token is the callback after client-side tokenization.
    var stripeHandler = StripeCheckout.configure({
        name: 'HARDBLACK',
        currency: 'hkd',
        key: 'pk_live_6Vr0iQulrwDiS11iYJzmR68i',
        locale: 'auto',
        token: function(token, addresses){
            console.log(token);
            $.ajax({
                type: "POST",
                url: "https://wt-6f60c90cb75ab3648ef60a005f2cfa2d-0.run.webtask.io/hbNodeStripeServer/charge",
                data: JSON.stringify({
                        "stripeEmail": token.email,
                        "stripeToken": token,
                        "totalPrice": totalPrice,
                        "items": items,
                        "contactAndAdress": contactAndAdress
                    }),
                dataType: "json",
                contentType: "application/json"
            })
            .done(function(){
                window.location.href = "/pages/thank-you";                
            })
        }         
    });

    // console.log(cartItems);

    
    // Validate form. Only confirm email is filled and valid.     
    function validEmail(value){
      return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
    };

    var emailInput = $('#infoForm input[type="email"]');

    if (!validEmail(emailInput.val())){
        emailInput.parent().css("background", "#ffacac")
    } else {
        
        emailInput.parent().css("background", "white");
        
        // Initiate client-side tokenization
        stripeHandler.open({                
          amount: totalPrice,
          email: contactAndAdress[0]["value"]
        })  
    }




}